import mapPoint from "./mapPoint.component";

const mapPointModule = angular
  .module("app.components.mapPoint", [])
  .component("mapPoint", mapPoint);

export default mapPointModule;



// WEBPACK FOOTER //
// ./src/components/mapPoint/mapPoint.module.js